import { useRef, useState } from 'react';

import {
  Box,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

import type {
  APILeadsListResultData,
  APIStatusChangeData,
  APILeadOverviewData,
} from 'types/api.types';

import { LEAD_ALL_STATUSES } from 'views/leads/constants';

import LeadStatusChange from 'views/leads/components/LeadStatusChange';

const UnarchiveLead = ({
  lead,
  onSuccess,
}: {
  lead: APILeadsListResultData | APILeadOverviewData;
  onSuccess: (data: APIStatusChangeData) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleStatusChangeSuccess = (data: APIStatusChangeData) => {
    handleClose();
    onSuccess(data);
  };

  return (
    <>
      <Button size="sm" colorScheme="red" onClick={handleOpen}>
        Restore
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={handleClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Restore Lead
            </AlertDialogHeader>

            <AlertDialogBody>
              <Box mb={4}>Select a status to restore this lead in:</Box>
              <LeadStatusChange
                lead={lead}
                onSuccess={handleStatusChangeSuccess}
                leadStatues={LEAD_ALL_STATUSES}
              />
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={handleClose}>
                Cancel
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default UnarchiveLead;
